<template>
  <div>
  
    <v-card-actions>
      <v-btn
        color="primary"
        outline
        block
        class="text-none"
        @click="
          access.includes('stats')
            ? goToStats()
            : (openPremiumDialog = true)
        "
      >
        <v-icon color="primary">mdi-chart-bar-stacked</v-icon>
        {{ $t('manageStats.details') }}
        <!--v-icon small color="yellow darken-2">mdi-star</v-icon-->
      </v-btn>
    </v-card-actions>
      

    <premium-dialog
      v-if="openPremiumDialog"
      :isTextDialogOpen="openPremiumDialog"
      :title="title"
      :explanation="explanation"
      :lottieUrl="lottieUrl"
      @confirm="closePremium()"
      @close-text-dialog="closePremium()"
      @cancel="closePremium()"
    >
    </premium-dialog>
  </div>
</template>

<script>
import PremiumDialog from './PremiumDialog';
export default {
  name: 'manageStats',
  components: {
    PremiumDialog,
  },
  data() {
    return {
      openPremiumDialog: false,
      typeTextDialog: 'noAccess',
      lottieUrl: 'images/dashboard.json',
      title: this.$t('premiumDialog.title.stats'),
      explanation: this.$t('premiumDialog.explanation.stats'),
    };
  },
  props: {
    pathId: {
      type: String,
      default: null,
    },
  },
  created() {},
  watch: {},
  computed: {
    offer() {
      return this.$store.getters['accounts/currentAccount'].offer || {};
    },
    access() {
      return (
        this.$store.getters['paths/getPathsAccess'][
          this.$route.params.pathId
        ] || []
      );
    },
    statsPath() {
      if (this.$store.state.stats.statsPaths[this.pathId]) {
        return this.$store.state.stats.statsPaths[this.pathId];
      }
      return null;
    },
    totalUsers() {
      if (!this.statsPath || !this.statsPath.nbUsers) {
        return null;
      }
      return this.statsPath.nbUsers.map((u) => u.value).reduce((a, b) => a + b);
    },
  },
  methods: {
    goToStats() {
      this.$router.push(`/stats/${this.pathId}`);
    },
    closePremium() {
      this.openPremiumDialog = false;
    },
  },
};
</script>

<style lang="sass" scoped>

.v-input--selection-controls
    margin: 0
    padding: 0
.pointer
  cursor: pointer
.manageTitle
  font-size: medium
  padding-left: 5px
.statsTitle
  text-transform: uppercase;
  font-size: x-small;
  text-align: center;
  text-justify: center;
.statsNumber
  font-size: large;
  text-align: center;
  text-justify: center;
</style>
